import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
  FlexBox,
  type IconNames,
  Text,
} from '@dixa/lib-shared-habla';

import { type SidekickAgentMode } from '../../../../../../utils/sdk/structuredResponse';

type SidekickModeSelectorProps = {
  agentMode: SidekickAgentMode;
  isDisabled: boolean;
  onAgentModeChange: (agentMode: SidekickAgentMode) => void;
};

const AGENT_MODES = {
  do: {
    label: 'Do',
    description: 'Make changes with tools',
    icon: 'ai',
  },
  plan: {
    label: 'Plan',
    description: 'Plan first, then carry it out',
    icon: 'list-ul-disc',
  },
} as const satisfies Record<
  SidekickAgentMode,
  { label: string; description: string; icon: IconNames }
>;

const AGENT_MODE_ORDER: readonly SidekickAgentMode[] = ['do', 'plan'];

export const SidekickModeSelector = ({
  agentMode,
  isDisabled,
  onAgentModeChange,
}: SidekickModeSelectorProps): JSX.Element => {
  const selected = AGENT_MODES[agentMode];

  return (
    <DropdownButton
      icon={selected.icon}
      buttonProps={{ variant: 'secondary', disabled: isDisabled }}
      fixed
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ closeDropdown }) => (
            <ButtonList>
              {AGENT_MODE_ORDER.map((mode) => (
                <ButtonList.Item
                  key={mode}
                  icon={AGENT_MODES[mode].icon}
                  isSelected={mode === agentMode}
                  buttonProps={{ type: 'button' }}
                  onClick={() => {
                    closeDropdown();
                    onAgentModeChange(mode);
                  }}
                >
                  <FlexBox
                    as="span"
                    flexDirection="column"
                    gap="100"
                    align="start"
                    padding="0 300 0 0"
                  >
                    {AGENT_MODES[mode].label}
                    <Text.Paragraph as="span" variant="4" subdued>
                      {AGENT_MODES[mode].description}
                    </Text.Paragraph>
                  </FlexBox>
                </ButtonList.Item>
              ))}
            </ButtonList>
          )}
        </DropdownButtonContext.Consumer>
      }
    >
      {selected.label}
    </DropdownButton>
  );
};
